import React from 'react';
import { createUseStyles } from 'react-jss';

import Constants from '../Constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { MzForm, MzFormInputText, MzSubmitButton, MzFormRadioButtonGroup, MzFormDropdown } from '../components/form';

import * as yup from 'yup';
import ValidationUtils from "../utils/ValidationUtils"


import ApiUtils from "../api/ApiUtils"

//import Swal from 'sweetalert2'


function SearchCat1(props) {

   // let location = useLocation();
   // let IdCategoria = location.state?.id_categoria;

    const [selectedTipologia, setSelectedTipologia] = React.useState("privato");
    const formikRef = React.useRef();

    const navigate = useNavigate();



    const initialValues = {
        tipologia: 'privato',
        giaInternet: '',
        operatore: '',
        indirizzo: '',
        nome: '',
        ragioneSociale: '',
        cellulare: '',
        email: '',


        accept: false,


    };



    const validationSchema = yup.object({

        tipologia: yup.string()
            .required(Constants.validation.required),

        giaInternet: yup.string()
            .required(Constants.validation.required),

        operatore: yup.string()
            .required(Constants.validation.required),

        indirizzo: yup.string()
            .required(Constants.validation.required),


        nome: yup.string().when('tipologia', {
            is: "privato",
            then: schema => schema.required(Constants.validation.required),
            otherwise: schema => schema.optional()
        }),


        ragioneSociale: yup.string().when('tipologia', {
            is: "azienda",
            then: schema => schema.required(Constants.validation.required),
            otherwise: schema => schema.optional()
        }),

        cellulare: yup.string()
            .required(Constants.validation.required)
            .phone_number(Constants.validation.invalid_phone)
            .nullable(),

        email: yup.string()
            .email("Email nn valida")
            .required(Constants.validation.required)
        ,

    })

    const onSubmit = async (data) => {

        const resp = await ApiUtils.post("tariff_comparator/v1/ans/c1/", data);
        debugger;
        if (resp.status == 200) {
          await window.Swal.fire({
                title: 'Tutto ok!',
                icon: 'success',
                confirmButtonText: 'Vai alle offerte'
                
            })

            //console.log(resp.data);

            navigate('/results1', {state:{data:resp.data}} )

        
        }
    }


    function onTipologiaChange(value) {

        setSelectedTipologia(value);
        formikRef.current.setFieldValue("nome", "");
        formikRef.current.setFieldValue("ragioneSociale", "");


    }



    const st = styles();
    return (
        <div style={{ width: "350px" }} className='mz_container flex flex-column justify-content-center align-items-center  mz_border_primary_color'>

            <MzForm initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit} innerRef={formikRef}>

                <MzFormRadioButtonGroup
                    onChange={(value) => onTipologiaChange(value)}
                    name="tipologia"
                    label="Tipologia"
                    options={[
                        { label: 'Privato', value: 'privato' },
                        { label: 'P.IVA/Azienda', value: 'azienda' },
                        // Aggiungi altre opzioni qui
                    ]}
                />


                <MzFormRadioButtonGroup
                    name="giaInternet"
                    label="Hai già internet a casa ?"
                    options={[
                        { label: 'Si', value: 'si' },
                        { label: 'No', value: 'no' },
                        // Aggiungi altre opzioni qui
                    ]}
                />



                <MzFormDropdown
                    name="operatore"
                    label="Con quale operatore ?"
                    options={[
                        { label: 'Fastweb', value: 'fastweb' },
                        { label: 'Iliad', value: 'iliad' },
                        { label: 'Linkem', value: 'linkem' },
                        { label: 'Sky wifi', value: 'sky' },
                        { label: 'Telecom Italia', value: 'telecom' },
                        { label: 'Tiscali', value: 'tiscali' },
                        { label: 'Vodafone', value: 'vodafone' },
                        { label: 'WindTre', value: 'wind' },
                        { label: 'Altro', value: 'altro' },
                    ]}
                />
                <MzFormInputText name="indirizzo" label="Indirizzo attivazione" />

                {selectedTipologia == "privato" ?
                    <MzFormInputText name="nome" label={Constants.labels.name_surname} />
                    :
                    <MzFormInputText name="ragioneSociale" label={Constants.labels.ragone_sociale} />
                }


                <MzFormInputText name="cellulare" label="Telefono cellulare" />
                <MzFormInputText name="email" label="Email" />

                <MzSubmitButton label="Confronta le offerte"></MzSubmitButton>

            </MzForm>






        </div>
    );
}

const styles = createUseStyles({
    container: {}
});

export default SearchCat1;